import React, { useEffect } from 'react';
import type { unstable_BlockerFunction as BlockerFunction } from 'react-router-dom';
import { unstable_useBlocker as useBlocker } from 'react-router-dom';

import { ActionDialog } from '@/components/shared/components/ActionDialog';
import { Text } from '@/components/shared/components/Text';
import { useDialog } from '@/components/shared/hooks/useDialog';

interface PageLeaveGuardProps {
  titleTextId: string;
  descriptionTextId: string;
  mainButtonTextId: string;
  condition?: boolean;
}

export const PageLeaveGuard = ({ condition = true, ...props }: PageLeaveGuardProps) => {
  const { opened, setOpened } = useDialog();

  const shouldBlock = React.useCallback<BlockerFunction>(
    ({ currentLocation, nextLocation }) => condition && currentLocation.pathname !== nextLocation.pathname,
    [condition],
  );

  const blocker = useBlocker(shouldBlock);

  useEffect(() => {
    if (blocker.state === 'blocked') {
      setOpened(true);
    }
  }, [blocker.state]);

  const handleClose = () => {
    setOpened(false);
    blocker.reset?.();
  };

  if (!blocker) return null;

  return (
    <ActionDialog
      opened={opened}
      setOpened={setOpened}
      handleClose={handleClose}
      onSubmit={() => blocker.proceed?.()}
      {...props}
      Title={<Text tId={props.titleTextId} />}
      Description={<Text tId={props.descriptionTextId} />}
      MainButton={<Text tId={props.mainButtonTextId} />}
      loading={blocker.state === 'proceeding'}
    />
  );
};
